import Link from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Network } from '../helpers';
import { ImageComponent } from '@/components/Image';

import { ScNetworkItem } from './styled';

export const NetworkItem: FC<Network> = ({ textKey, icon, link, id }) => {
  const { t } = useTranslation('common');

  return (
    <Link href={link} target="_blank" aria-label={id}>
      <ScNetworkItem>
        <ImageComponent width={80} height={80} src={icon} alt={id} />
        <div className="text">{t(textKey, { network: id })}</div>
      </ScNetworkItem>
    </Link>
  );
};
